/**
 * Public routes (§48). Paths are fixed: they are used in emails, QR codes and redirects
 * (WEB_ROUTES in @lsc/shared). The pages are small and part of the entry chunk on purpose –
 * no loading flash on the participant's first visit; admin pages are split off (WS6).
 */
import type { RouteObject } from 'react-router';
import { ActivationPage } from './pages/ActivationPage';
import { CodeEntryPage } from './pages/CodeEntryPage';
import { StatusPage } from './pages/StatusPage';
import { SuccessPage } from './pages/SuccessPage';
import { VerifyPage } from './pages/VerifyPage';

export const publicRoutes: RouteObject[] = [
  { index: true, element: <CodeEntryPage /> },
  { path: 'a/:code', element: <ActivationPage /> },
  { path: 'verify', element: <VerifyPage /> },
  { path: 'status', element: <StatusPage /> },
  { path: 'success', element: <SuccessPage /> },
];
